import { render } from "./CouponForm.vue?vue&type=template&id=80408aca"
import script from "./CouponForm.vue?vue&type=script&lang=js"
export * from "./CouponForm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__